var exports = {
  "N": "Link__m5BDqY",
};

module.exports = exports;
